import { Component, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, filter, mergeMap } from 'rxjs/operators';
import { ApiClientConstant, ApiConnector, ParseKeys, RequestQueryPayload, Table } from '@cureskin/api-client';
import { ConnectionService } from '../../../../services/connection-service';
import { AppConfig } from '../../../app.config';
import { InputType } from '../../../../../typings/client/input';
import { ValidationService } from '../../../../services/validation-service';
import { Broadcaster } from '../../../../components/broadcaster';
import { MatDialog } from '@angular/material/dialog';
import { ProductHighlightModalComponent } from 'src/components/modal/product-highlight-modal/product-highlight-modal.component';
import { ProductCollectionConfirmationModalComponent } from 'src/components/modal/product-collection-confirmation-modal/product-collection-confirmation-modal.component';
import { FieldVisibilityService } from '../../../../services/field-visibility-service/field-visibility.service';
import { ExtraImageWithTagPersisted, ExtraImagesWithTagsComponent } from './extra-images-with-tags/extra-images-with-tags.component';

@Component({
    selector: 'catalog-edit',
    templateUrl: './catalog-edit.html',
    styleUrls: ['./catalog-edit.scss'],
    standalone: false
})
export class CatalogEditComponent implements OnDestroy {
  public autoCompleteProductController: UntypedFormControl = new UntypedFormControl();
  public autoCompleteMainProductController: UntypedFormControl = new UntypedFormControl();
  productOptions: Observable<Array<{ name: string; object: any }>>;
  mainProductOptions: Observable<Array<{ name: string; object: any }>>;
  Name: string;
  isValidImageFile: boolean = true;
  productObj: any;
  articles: Array<any> = [];
  articleId: string;
  articleWithTagId: string;
  articleObj: any;
  articleWithTagObj: any;
  userTagForArticle: string;
  disabled: boolean;
  safteyProfileOptions: Array<InputType.SelectOption>;
  requiresApprovalOptions: Array<InputType.SelectOption>;
  alternateNames: string[] = [];
  alternateNameInput: string = '';
  userTagList: string[] = [
    'MALE',
    'FEMALE',
    'AGE_BETWEEN_20_TO_40',
    'AGE_BELOW_20',
    'AGE_ABOVE_40',
    'ACNE_OR_PIMPLES',
    'FACE_PIGMENTATION',
    'HAIR_FALL',
    'DANDRUFF',
    'SMOKER',
    'POST_ACNE',
    'ACNE_DETECTED',
    'HORMONAL_IMBALANCE',
    'PREGNANT',
    'STEROID',
    'NEW_MOM',
    'BODY',
    'COMPLEX_ARTICLE',
  ];
  initialArticleId: string;
  initialArticleWithTagId: string;
  mainConcerns: any;
  imageSrc: any;
  imageFiles: Array<any> = [];
  ui: { minEffectivePrice: number, maxSellingPrice: number, cgst: number, sgst: number } = {
    minEffectivePrice: 0,
    maxSellingPrice: 0,
    cgst: 0,
    sgst: 0,
  };
  GST_SLABS: Array<number> = [5, 12, 18];
  gstSelectedSlab: number;
  productTags: Array<string> = [];
  inventoryStatus: Array<InputType.SelectOption>;
  paymentOptions: Array<InputType.SelectOption>;
  trackingCategory: Array<InputType.SelectOption>;
  gstnOptions: Array<InputType.SelectOption>;
  categories: Array<InputType.SelectOption>;
  subCategories: Array<InputType.SelectOption>;
  quantityUnits: Array<InputType.SelectOption>;
  subscriptions: Array<Subscription>;
  shopTags: Array<any> = [];
  excludeBoostProductsTags: Array<any> = [];
  boostYourRegimenTags: Array<any> = [];
  currentAttachedCatalog: any;
  MAX_IMAGE_SIZE_IN_KB: number = 150000;
  keyActive: string;
  supportingActive: string;
  baseIngredients: string;
  extraImages: any[] = [];
  currentUser: any;
  isInventoryStatusDiscontinued:boolean = false;
  isMainProduct: boolean = true;
  productHighlights: Array<any> = [];
  heroIngredients: Array<Table.HeroIngredient> = [];
  heroIngredientsLanguageStrings: Array<Table.LanguageString> = [];
  isHeroIngredientsChanged: boolean = false;
  newProduct: boolean = false;
  originalPriceFields: { mrp?: number; price?: number; effectiveCostPrice?: number } = {};
  @ViewChild(ExtraImagesWithTagsComponent) extraImagesWithTags: ExtraImagesWithTagsComponent;
  constructor(private router: Router,
    private conn: ConnectionService,
    private route: ActivatedRoute,
    public appConfig: AppConfig,
    private broadcasterService: Broadcaster,
    private validationService: ValidationService,
    private readonly dialog: MatDialog,
    private fieldVisibilityService: FieldVisibilityService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    // this.dataSourceSeller = Observable
    //   .create((observer: any) => observer.next(this.Name))
    //   .pipe(mergeMap((token: string) => this.getSellers(token)));
  }

  async ngOnInit(): Promise<any> {
    this.currentUser = this.conn.getCurrentUser();
    this.productOptions = this.autoCompleteProductController.valueChanges
      .pipe(
        debounceTime(300),
        filter((token: string) => !!token.length),
        mergeMap((token: string) => this.getProducts(token)));
    this.mainProductOptions = this.autoCompleteMainProductController.valueChanges
      .pipe(
        debounceTime(300),
        filter((token: string) => !!token.length),
        mergeMap((token: string) => this.getProducts(token)));
    this.subscriptions = [];
    await this.fieldVisibilityService.loadCatalogFieldsToHide();
    this.shopTags = Object.keys(ApiClientConstant.User.MarketingTags).map((key: string) => ({
      value: ApiClientConstant.User.MarketingTags[key],
      display: ApiClientConstant.User.MarketingTags[key],
    }));
    this.excludeBoostProductsTags = Object.keys(this.appConfig.Shared.ExcludeBoostProductsTags).map((key: string) => ({
      value: this.appConfig.Shared.ExcludeBoostProductsTags[key],
      display: this.appConfig.Shared.ExcludeBoostProductsTags[key],
    }));
    this.boostYourRegimenTags = Object.entries(this.appConfig.Shared.boostYourRegimenTags).map(([key, value]: [string, string]) => ({
      value: key,
      display: value,
    }));
    this.gstnOptions = [
      { display: 'EssentialAesthetics', value: '29AUOPS1203M2Z5' },
      { display: 'CureSkin', value: '29AAKFH3537K1ZY' },
      { display: 'Cure and Care Wellness Private Limited', value: '29AAJCC8379A1ZD' },
      { display: 'Dr. Gomez\'s Skin Innovations', value: '29CDXPG3751L1ZR' },
    ];
    this.paymentOptions = [
      { display: 'Indefinite', value: ApiClientConstant.Catalog.REORDER_TYPE.INDEFINITE },
      { display: 'Limited', value: ApiClientConstant.Catalog.REORDER_TYPE.LIMITED },
      { display: 'Never', value: ApiClientConstant.Catalog.REORDER_TYPE.NEVER },
    ];
    this.trackingCategory = [
      { display: 'Sunscreen', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.SUNCSCREEN },
      { display: 'Facewash', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.FACEWASH },
      { display: 'Repair', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.REPAIR },
      { display: 'Moisturiser', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.MOISTURISER },
      { display: 'Protectors', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.PROTECTORS },
      { display: 'Skin Repair', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.SKIN_REPAIR },
      { display: 'Hair Repair', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.HAIR_REPAIR },
      { display: 'Nutraceutical', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.NUTRACEUTICAL },
      { display: 'Oral Medicine', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.ORAL_MEDICINE },
      { display: 'Hair Hygiene', value: ApiClientConstant.Catalog.TRACKING_CATEGORY_TYPE.HAIR_HYGIENE },
    ];
    this.categories = Object.keys(ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories)
      .map((category: keyof typeof ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories) => ({
        display: category,
        value: category,
      }));
    this.subCategories = [
      { display: 'ANTI_ACNE', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.FACE[0] },
      { display: 'DARK_CIRCLES', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.FACE[1] },
      { display: 'GLOW_RADIANCE_MAINTENANCE', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.FACE[2] },
      { display: 'HYPER_PIGMENTATION', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.FACE[3] },
      { display: 'SCARRING', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.FACE[4] },
      { display: 'OTHER_FACE', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.FACE[5] },
      { display: 'FRIZZY_HAIR', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.HAIR[1] },
      { display: 'GREY_HAIR', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.HAIR[2] },
      { display: 'DANDRUFF', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.HAIR[0] },
      { display: 'HAIRFALL', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.HAIR[3] },
      { display: 'OTHER_HAIR', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.HAIR[4] },
      { display: 'BODY_DRYNESS', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.BODY[0] },
      { display: 'OTHER_BODY', value: ApiClientConstant.Catalog.CategoriesAndAllowedSubCategories.BODY[1] },
    ];
    this.safteyProfileOptions = [
      { display: 'Recommend for all',
        value: ApiClientConstant.Catalog.SAFTEY_PROFILE_OPTION.RECOMMEND_FOR_ALL },
      { display: 'Avoid in pregnancy and breastfeeding',
        value: ApiClientConstant.Catalog.SAFTEY_PROFILE_OPTION.AVOID_IN_PREGNANCY_AND_BREASTFEEDING },
      { display: 'Avoid in pregnancy and safe in breastfeeding',
        value: ApiClientConstant.Catalog.SAFTEY_PROFILE_OPTION.AVOID_IN_PREGNANCY_AND_SAFE_IN_BREASTFEEDING },
      { display: 'Not recommended to 16 or below',
        value: ApiClientConstant.Catalog.SAFTEY_PROFILE_OPTION.NOT_RECOMMENDED_TO_16_OR_BELOW },
      { display: 'Avoid in Pregnancy/BF and Teenagers',
        value: ApiClientConstant.Catalog.SAFTEY_PROFILE_OPTION.AVOID_IN_PREGNANCY_BREASTFEEDING_AND_TEENAGER },
    ];
    this.requiresApprovalOptions = [
      { display: 'ALWAYS', value: ApiClientConstant.Catalog.RequiresApprovalType.ALWAYS },
      { display: 'NEVER', value: ApiClientConstant.Catalog.RequiresApprovalType.NEVER },
      { display: 'IF SAME CLASS REGIMEN PRESENT', value: ApiClientConstant.Catalog.RequiresApprovalType.IF_SAME_CLASS_REGIMEN_PRESENT },
    ]
    this.inventoryStatus = Object.keys(ApiClientConstant.Catalog.InventoryStatus).map((key: string) => ({
      display: ApiClientConstant.Catalog.InventoryStatus[key].replace(/_/g, ' '),
      value: ApiClientConstant.Catalog.InventoryStatus[key],
    }));
    this.quantityUnits = [
      { display: 'mg', value: 'mg' },
      { display: 'gms', value: 'gms' },
      { display: 'ml', value: 'ml' },
      { display: 'units', value: 'units' },
      { display: 'capsules', value: 'capsules' },
      { display: 'tablets', value: 'tablets' },
      { display: 'sachets', value: 'sachets' },
    ];
    this.productObj = new Table.Catalog();
    this.productObj.set('images', []);
    this.productObj.set('tax', {});
    this.subscribeToUrlQueryParams();
    this.mainConcerns = await this.conn.findMainConcernsOptions();
    this.articles = await this.conn.getArticleData({
      descending: 'createdAt',
    });
    if (this.productObj.get('articleWithTag')) {
      this.articleWithTagObj = this.productObj.get('articleWithTag');
      const pointer: {id: string}[] = Object.values(this.articleWithTagObj);
      this.userTagForArticle = <string>Object.keys(this.articleWithTagObj)[0];
      this.articleWithTagObj = await this.conn.getArticle(pointer[0].id, ['product']);
    } else {
      this.articleWithTagObj = new Table.ArticleData();
      this.updateDefaultValue(this.articleWithTagObj);
    }
    if (!this.productObj.get('article')) {
      this.articleObj = new Table.ArticleData();
      this.updateDefaultValue(this.articleObj);
    } else {
      this.articleObj = this.productObj.get('article');
      this.currentAttachedCatalog = await this.conn.getArticle(this.articleObj.id, ['product']);
      this.articleObj = this.currentAttachedCatalog;
    }
    if (this.productObj?.id
      && this.productObj.get('inventoryStatus') === 'DISCONTINUED') {
      this.isInventoryStatusDiscontinued = true;
    }
  }

  async getProducts(name: string): Promise<Array<{ name: string; object: any }>> {
    const products = await this.conn.findCatalogs({
      where: {
        title: { $regex: name, $options: 'i' },
        inventoryStatus: ['AVAILABLE', 'UNAVAILABLE', 'RESTRICTED'],
      },
      project: ['title', 'quantity', 'quantityUnit', 'type', 'margUnit', 'mrp', 'price'],
      ascending: 'margUnit',
      limit: 10,
    });
    return products.map((product: any): { name: string; object: any } => ({
      name: this.getProductDisplayName(product),
      object: product,
    }));
  }

  getProductDisplayName(product: any): string {
    return `${product.get('title')} [ ${
      (product.get('margUnit') || 1) > 1
        ? `${product.get('margUnit')} sheets, `
        : ''
    }${product.get('quantity')}${product.get('quantityUnit')} ] ${product.get('type') === 'sample' ? '(sample)' : ''}`;
  }

  autoCompleteOnProductSelect(item: { name: string; object: any }): void {
    this.productObj.set('alternateProduct', item.object);
    this.autoCompleteProductController.setValue('');
  }

  removeAlternateProduct(): void {
    this.productObj.unset('alternateProduct');
  }

  subscribeToUrlQueryParams(): void {
    this.subscriptions.push(this.route.parent.params.subscribe(() => {
      if (this.route.parent.snapshot.data.catalog) {
        this.initialiseFromResolvedCatalog(this.route.parent.snapshot.data.catalog);
      }
    }));
  }

  private initialiseFromResolvedCatalog(catalog: Table.Catalog): void {
    this.productObj = catalog;
    this.originalPriceFields = {
      mrp: this.productObj.get('mrp'),
      price: this.productObj.get('price'),
      effectiveCostPrice: this.productObj.get('effectiveCostPrice'),
    };
    const mainProductRef: Table.Catalog = this.productObj.get('mainProduct');
    this.isMainProduct = !mainProductRef || mainProductRef.id === this.productObj.id;
    this.productHighlights = this.productObj?.get('productHighlights') || [];
    if (this.productObj?.get('heroIngredients')) {
      this.heroIngredients = this.productObj?.get('heroIngredients');
      this.heroIngredientsLanguageStrings = this.heroIngredients
        .filter((ingredient: Table.HeroIngredient) => !!ingredient)
        .map((ingredient: Table.HeroIngredient) => ingredient.get('nameLanguageString'))
        .filter((languageString: Table.LanguageString) => !!languageString);
      this.productObj.set('heroIngredientsLanguageStrings', this.heroIngredientsLanguageStrings);
    }
    if (this.productObj.get('ingredientsLanguageString')) {
      this.productObj.set('tempingredientsLanguageStrings', [this.productObj.get('ingredientsLanguageString')]);
    }
    if (!this.productObj.has('conditions')) {
      this.productObj.set('conditions', []);
    }
    if (this.productObj.get('article')) {
      this.articleId = this.productObj.get('article').id;
      this.initialArticleId = this.productObj.get('article').id;
    }
    if (this.productObj.get('articleWithTag')) {
      this.articleWithTagId = this.productObj.get('articleWithTag').id;
      this.initialArticleWithTagId = this.productObj.get('articleWithTag').id;
    }
    if (this.productObj.get('ingredients')) {
      const ingredients = this.productObj.get('ingredients');
      this.keyActive = ingredients.keyActive;
      this.baseIngredients = ingredients.baseIngredients;
      this.supportingActive = ingredients.supportingActive;
    }
    this.gstSelectedSlab = this.productObj.get('tax').cgst * 2;
    this.initialiseExtraImages();
  }

  private initialiseExtraImages(): void {
    if (this.productObj.get('extraImages')) {
      const extraImages = this.productObj.get('extraImages');
      this.extraImages = Array.from({ length: extraImages.length || 0 }, (_: any, i: number): boolean => {
        this.productObj.set(`extraImages_${i}`, extraImages[i]);
        return true;
      });
    }
  }

  updateDefaultValue(articleObj: any): void {
    const data = {
      params: { srcLanguageString: [], list: [], sections: [], lifestyle: [], diet: [] },
      template: 'imageArticle',
      clickToAction: 'BUY_PRODUCT',
      cssLink: 'https://assets.cureskin.com/app/css/style.min.css',
    };
    articleObj.set({ ...data, params: { ...data.params } });
  }

  // getSellers(name: string): Promise<any> {
  //   return this.conn.getSellers({ limit: 10, offset: 0 })
  //     .then((sellers: any) => sellers.map((object: any) => ({ name: object.get('Name'), object })));
  // }

  async saveProductHighlights(): Promise<boolean> {
    try {
      for (const highlight of this.productHighlights) {
        if (highlight.dirty() || !highlight.id) {
          await highlight.save();
        }
      }
      return true;
    } catch (error) {
      this.broadcasterService.broadcast('NOTIFY', {
        message: 'Error saving product highlights: ' + (error.message || error),
        type: this.appConfig.Shared.Toast.Type.ERROR
      });
      return false;
    }
  }

  async saveProduct(): Promise<void> {
    if (!this.productObj.id) {
      this.newProduct = true;
    }
    this.checkPriceRelatedFieldChanges();
    if (this.productObj.get('inventoryStatus') === ApiClientConstant.Catalog.InventoryStatus.DISCONTINUED
      && !this.productObj.get('alternateProduct')) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'Alternate Product is missing',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    if (this.productObj.get('inventoryStatus') === ApiClientConstant.Catalog.InventoryStatus.DISCONTINUED
      && this.productObj.get('type') === ApiClientConstant.Catalog.Type.MAIN) {
      const isPartOfCombo = await this.isPartOfCombo();
      if (isPartOfCombo) {
        this.broadcasterService.broadcast('NOTIFY', { message: 'This product is present in combo, It cannot be discontinued',
          type: this.appConfig.Shared.Toast.Type.ERROR });
        return;
      }
    }
    if (this.productHighlights.length === 1 || this.productHighlights.length > 2) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'Every product should have 0 or 2 product highlights only',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    const isProductHighlightValid = this.productHighlights.every((highlight: Table.ProductHighlight) => {
      return highlight.get('descriptionLanguageString') && highlight.get('image');
    });
    if (!isProductHighlightValid) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'Product highlight image and description are required',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    const isProductHighlightSaved = await this.saveProductHighlights();
    if (!isProductHighlightSaved) {
      return;
    }
    // if (this.productObj.get('prescriptionRequired') && !this.productObj.get('genericName')) {
    //   this.broadcasterService.broadcast('NOTIFY', { message: 'Generic Name missing for a rx-product',
    //     type: this.appConfig.Shared.Toast.Type.ERROR });
    //   return;
    // }
    if (this.productObj.get('ingredients')?.keyActive !== this.keyActive
      || this.productObj.get('ingredients')?.supportingActive !== this.supportingActive
      || this.productObj.get('ingredients')?.baseIngredients !== this.baseIngredients) {
      const ingredients = {
        keyActive: this.keyActive,
        supportingActive: this.supportingActive,
        baseIngredients: this.baseIngredients,
      };
      this.productObj.set('ingredients', ingredients);
    }
    if (this.productObj.get('effectiveCostPrice') <= 0) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'effective cost price can;t be zero',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    if (this.articleId && this.articleId !== this.initialArticleId) {
      const articleObj = this.articles.filter((article: any) => article.id === this.articleId)[0];
      this.productObj.set('article', articleObj);
    }
    if (this.articleWithTagId && this.articleWithTagId !== this.initialArticleWithTagId) {
      const articleObj = this.articles.filter((article: any) => article.id === this.articleId)[0];
      this.productObj.set('articleWithTag', articleObj);
    }
    if (this.productObj.dirtyKeys().includes('inventoryStatus')
        && [ApiClientConstant.Catalog.InventoryStatus.DISCONTINUED]
          .includes(this.productObj.get('inventoryStatus'))) {
      const variantsHavingThisProduct = await ApiConnector.find(Table.Regimen, {
        where: {
          type: { $in: [ApiClientConstant.Regimen.Type.MAIN, ApiClientConstant.Regimen.Type.ALTERNATE] },
          active: true,
          $or: [{ products: { $in: [this.productObj] } }, { 'variants.products': { $in: [this.productObj] } }],
        },
        project: ['regimenId'],
      });
      if (variantsHavingThisProduct?.length) {
        this.broadcasterService.broadcast('NOTIFY', { message: `Regimen or Regimen Varaints have this product,
        ${variantsHavingThisProduct.map((regimen:any):string => regimen.get('regimenId'))}`,
        type: this.appConfig.Shared.Toast.Type.ERROR });
        return;
      }
    }
    if (isNaN(this.productObj.get('tax').cgst)) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'select GST slab',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    if (!this.validationService.validateMargId(this.productObj.get('margId'))) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'MargId must be greater than 0',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    if (!this.productObj.get('subCategory') || !this.productObj.get('category')) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'category or subCategory is not available',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }

    if (this.productObj.id && !this.isMainProduct && !this.productObj.get('mainProduct')) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'Please select a Main Product or mark this product as main',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }

    if (this.extraImagesWithTags) {
      const isValid: boolean = await this.extraImagesWithTags.validate();
      if (!isValid) return;
      const persistedExtraImages: Array<ExtraImageWithTagPersisted> = this.extraImagesWithTags.getValue();
      if (persistedExtraImages.length) {
        this.productObj.set('extraImagesWithTags', persistedExtraImages);
      } else {
        this.productObj.unset('extraImagesWithTags');
      }
    }

    if (this.extraImages?.length) {
      const images: any[] = [];
      let hasUpdatedExtraImages = false;

      this.extraImages.forEach((isVisible: boolean, index: number): void => {
        const key = `extraImages_${index}`;
        const img = this.productObj.get(key);

        const hasImg = img != null && !(Array.isArray(img) && img.length === 0);

        if (hasImg) {
          hasUpdatedExtraImages = true;
        }

        if (isVisible && hasImg) {
          images.push(img);
        }
      });

      if (hasUpdatedExtraImages) {
        this.extraImages.forEach((_isVisible: boolean, index: number): void => {
          this.productObj.unset(`extraImages_${index}`);
        });

        this.productObj.set('extraImages', images);
      }
    }

    const imageStr = this.articleObj?.get('params');
    if (imageStr?.articleImagesLanguageString?.length) {
      this.articleObj.set('product', this.productObj);
      await this.articleObj.save();
      this.productObj.set('article', this.articleObj);
    } else {
      this.productObj.unset('article');
    }

    const imageStrForArticleWithTag = this.articleWithTagObj?.get('params');
    if (imageStrForArticleWithTag?.articleImagesLanguageString?.length && this.userTagForArticle) {
      this.articleWithTagObj.set('product', this.productObj);
      await this.articleWithTagObj.save();
      this.productObj.set('articleWithTag', { [this.userTagForArticle]: this.articleWithTagObj });
    } else {
      this.productObj.unset('articleWithTag');
    }

    if (!this.isValidImageFile) return;
    if (this.isPricesInDecimal()) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'No decimals in MRP or price.',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    if (this.alternateNames?.length) {
      this.productObj.set('alternateNames', this.alternateNames);
    }
    const areHeroIngredientsValid = await this.setHeroIngredients();
    if (!areHeroIngredientsValid) return;
    if ((this.productObj.get('heroIngredients') || []).length > 3) {
      this.broadcasterService.broadcast('NOTIFY', { message: 'Hero Ingredients can\'t be more than 3',
        type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    try {
      this.disabled = true;
      this.productObj.unset('tempingredientsLanguageStrings');
      await this.productObj.save();
      if (this.newProduct) {
        const dialogRef = this.dialog.open(ProductCollectionConfirmationModalComponent, {
        });
        this.subscriptions.push(dialogRef.afterClosed().subscribe((addToCollection: boolean) => {
          if (addToCollection) {
            this.router.navigate(['/productCollections/getAllProductCollections']);
          } else {
            this.router.navigate([`/products/catalog/${this.productObj.id}`]);
          }
        }));
        return;
      }
      this.router.navigate([`/products/catalog/${this.productObj.id}`]);
    } catch (error) {
      this.disabled = false;
      this.broadcasterService.broadcast('NOTIFY', { message: error.message || error,
        type: this.appConfig.Shared.Toast.Type.ERROR });
    }
  }

  async setHeroIngredients(): Promise<boolean> {
    const currentHeroIngredients = (this.productObj?.get('heroIngredients') || [])
      .filter((ingredient: Table.HeroIngredient) => !!ingredient);
    const selectedLanguageStrings = (this.heroIngredientsLanguageStrings || [])
      .filter((languageString: Table.LanguageString) => !!languageString);

    if (selectedLanguageStrings.length === 0 && this.isHeroIngredientsChanged) {
      this.productObj.unset('heroIngredients');
      this.productObj.unset('heroIngredientsLanguageStrings');
      return true;
    }

    const filteredExistingIngredients = currentHeroIngredients.filter((ingredient: Table.HeroIngredient) =>
      this.isIngredientSelected(ingredient, selectedLanguageStrings)
    );

    const newLanguageStrings = selectedLanguageStrings.filter((languageString: Table.LanguageString) =>
      !this.hasCorrespondingHeroIngredient(languageString, filteredExistingIngredients)
    );

    if (newLanguageStrings.length === 0) {
      this.productObj.set('heroIngredients', filteredExistingIngredients);
      this.productObj.unset('heroIngredientsLanguageStrings');
      return true;
    }

    try {
      const newHeroIngredients = await this.fetchNewHeroIngredients(newLanguageStrings);
      const missingIngredientNames = newLanguageStrings
        .filter((_languageString: Table.LanguageString, index: number) => !newHeroIngredients[index])
        .map((languageString: Table.LanguageString): string => languageString.get('en') || languageString.id);
      if (missingIngredientNames.length > 0) {
        this.broadcasterService.broadcast('NOTIFY', {
          message: `No HeroIngredient record found for: ${missingIngredientNames.join(', ')}. Create it on the Hero Ingredients page before saving.`,
          type: this.appConfig.Shared.Toast.Type.ERROR
        });
        return false;
      }
      this.productObj.set('heroIngredients', [...filteredExistingIngredients, ...newHeroIngredients]);
      this.productObj.unset('heroIngredientsLanguageStrings');
      return true;
    } catch (error) {
      this.broadcasterService.broadcast('NOTIFY', {
        message: 'Failed to fetch hero ingredients: ' + (error.message || error),
        type: this.appConfig.Shared.Toast.Type.ERROR
      });
      return false;
    }
  }

  onHeroIngredientsChange(updatedHeroIngredients: any[]): void {
    this.isHeroIngredientsChanged = true;
    this.heroIngredientsLanguageStrings = updatedHeroIngredients || [];
  }

  private isIngredientSelected(ingredient: Table.HeroIngredient, selectedLanguageStrings: Array<any>): boolean {
    const ingredientLanguageStringId = ingredient.get('nameLanguageString')?.id;
    return selectedLanguageStrings.some(
      (languageString: any) => languageString.id === ingredientLanguageStringId
    );
  }

  private hasCorrespondingHeroIngredient(
    languageString: any,
    heroIngredients: Array<Table.HeroIngredient>
  ): boolean {
    return heroIngredients.some(
      (ingredient: Table.HeroIngredient) =>
        ingredient.get('nameLanguageString')?.id === languageString.id
    );
  }

  private async fetchNewHeroIngredients(newLanguageStrings: Array<Table.LanguageString>): Promise<Array<Table.HeroIngredient>> {
    return await Promise.all(newLanguageStrings.map((languageString: any) =>
      this.fetchHeroIngredientByLanguageString(languageString)
    ));
  }

  private async fetchHeroIngredientByLanguageString(languageString: any): Promise<Table.HeroIngredient> {
    const nameLanguageStringPointer = {
      __type: 'Pointer',
      className: 'LanguageString',
      objectId: languageString.id,
    };
    const queryPayload = { where: { nameLanguageString: nameLanguageStringPointer } };
    return await this.conn.findHeroIngredient(queryPayload);
  }

  updateTaxDetails(): void {
    this.productObj.get('tax').cgst = (this.gstSelectedSlab / 2);
    this.productObj.get('tax').sgst = (this.gstSelectedSlab / 2);
    const price = this.productObj.get('price') || 0;
    const cgst = this.productObj.get('tax').cgst || 0;
    const sgst = this.productObj.get('tax').sgst || 0;
    this.ui.cgst = (price * (cgst / (100 + sgst + cgst)));
    this.ui.sgst = (price * (sgst / (100 + sgst + cgst)));
  }

  onLanguageStringTagsUpdate(tags: Array<any>): void {
    this.productTags = tags.map((tag: any) => tag.get('name'));
  }

  isPricesInDecimal(): boolean {
    return this.isDecimal(this.productObj.get('mrp')) || this.isDecimal(this.productObj.get('price'));
  }

  isDecimal(value: number): boolean { return (value % 1 !== 0); }

  onMainProductToggleChange(isMain: boolean): void {
    if (isMain) {
      this.productObj.set('mainProduct', this.productObj);
    } else {
      this.productObj.unset('mainProduct');
    }
    this.autoCompleteMainProductController.setValue('');
  }

  autoCompleteOnMainProductSelect(item: { name: string; object: any }): void {
    this.productObj.set('mainProduct', item.object);
    this.autoCompleteMainProductController.setValue('');
  }

  removeMainProduct(): void {
    this.productObj.unset('mainProduct');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    delete this.subscriptions;
    delete this.productObj;
    delete this.router;
    delete this.conn;
    delete this.route;
    delete this.appConfig;
    delete this.validationService;
  }

  addExtraImages(): void {
    this.extraImages.push(true);
  }
  removeExtraImages(i: number): void {
    this.extraImages[i] = false;
  }

  async addPregAndBfTags(event: any): Promise<any> {
    const [ languageStringTag ] = await this.conn.getLanguageTagsByName(
      [ApiClientConstant.LanguageStringTagName.PREGNANCY_AND_BREASTFEEDING_SAFE]);
    if (!languageStringTag) {
      return;
    }
    const tags = this.productObj.get('tags') || [];
    if (event === ApiClientConstant.Catalog.SAFTEY_PROFILE_OPTION.RECOMMEND_FOR_ALL) {
      tags.push(languageStringTag);
      this.productObj.set('tags', tags);
    } else {
      const index = tags.findIndex((obj: any) => obj.id === languageStringTag.id);
      if (index >= 0) {
        tags.splice(index, 1);
        this.productObj.set('tags', tags);
      }
    }
  }

  async isPartOfCombo(): Promise<boolean> {
    const margId = this.productObj.get('margId');
    const escapedMargId = margId.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
    const regexPattern = `.*${escapedMargId}.*`;
    const payload: RequestQueryPayload<Table.Catalog> = {
      where: {
        margId: { $regex: regexPattern, $options: 'i' },
        objectId: { $ne: this.productObj.id },
        inventoryStatus: { $in: ['AVAILABLE', 'UNAVAILABLE'] },
      },
    };
    const count = await ApiConnector.count(Table.Catalog, payload);
    return count > 0;
  }

  addAlternateName(): void {
    if (this.alternateNameInput && !this.alternateNames.includes(this.alternateNameInput.trim())) {
      this.alternateNames.push(this.alternateNameInput.trim());
      this.alternateNameInput = '';
    }
  }

  removeAlternateName(index: number): void {
    this.alternateNames.splice(index, 1);
  }

  async addProductHighlights(): Promise<void> {
    if (this.productHighlights?.length >= 2) return;
    const productHighlight = new Table.ProductHighlight();
    productHighlight.set('image', '');
    this.productHighlights.push(productHighlight);
  }

  removeProductHighlights(index: number): void {
    this.productHighlights.splice(index, 1);
    this.productObj.set('productHighlights', this.productHighlights);
  }

  async editProductHighlights(highlight: Table.ProductHighlight, index: number): Promise<void> {
    const dialogRef = this.dialog.open(ProductHighlightModalComponent, { data: { selectedHighlight: highlight } });
    this.subscriptions.push(dialogRef.afterClosed().subscribe((imageUrl: string) => {
      if (imageUrl) {
        const productHighlight = this.productHighlights[index];
        if (productHighlight) {
            productHighlight.set('image', imageUrl);
          this.productObj.set('productHighlights', this.productHighlights);
        }
      }
    }));
  }

  onHighlightDescriptionChange(highlight: any, languageStringObj: any): void {
    if (!languageStringObj) return;
    highlight.set('description', languageStringObj.get('en'));
    this.productObj.set('productHighlights', this.productHighlights);
  }

  addHeroIngredients(): void {
    this.router.navigate([`/products/catalogs/hero-ingredient/new`]);
  }

  private checkPriceRelatedFieldChanges(): void {
    const priceFieldChecks: Array<{
      key: 'mrp' | 'price' | 'effectiveCostPrice';
      logLabel: string;
      message: string;
    }> = [
      { key: 'mrp', logLabel: 'MRP', message: 'price related field changes: MRP was changed from {{originalValue}} to {{currentValue}} by {{username}}' },
      { key: 'price', logLabel: 'Price', message: 'price related field changes: Selling price was changed from {{originalValue}} to {{currentValue}} by {{username}}' },
      { key: 'effectiveCostPrice', logLabel: 'Effective Cost Price', message: 'price related field changes: Effective Cost Price was changed from {{originalValue}} to {{currentValue}} by {{username}}' },
    ];

    for (const { key, logLabel, message } of priceFieldChecks) {
      const originalValue = this.originalPriceFields[key];
      const currentValue = this.productObj.get(key);

      if (originalValue !== undefined && currentValue !== originalValue) {
        this.broadcasterService.broadcast('productPriceChanged', { message: message.replace('{{originalValue}}', originalValue.toString()).replace('{{currentValue}}', currentValue.toString()).replace('{{username}}', this.currentUser.get('username')) });
        }
      }
    }

    protected apiClientConstant: ApiClientConstant = ApiClientConstant;
  }
